import './TransactionDetailsScreen.scss';
import {useCallback, useEffect, useState} from "react";
import {TransactionType} from "../../../shared/models/common.model";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {CommonService} from "../../../shared/services";
import BackComponent from "../../../shared/components/back/BackComponent";
import CardComponent from "../../../shared/components/card/CardComponent";
import LoaderComponent from "../../../shared/components/loader/LoaderComponent";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import ContactInfoCardComponent from "../contact-info-card/ContactInfoCardComponent";
import PaymentDetailsComponent from "../../payment-details/PaymentDetailsComponent";
import {ImageConfig} from "../../../constants";
import moment from "moment-timezone";
import AttachmentCard from "../../../shared/components/attachment-card/AttachmentCardComponent";
import SecureCheckoutComponent from "../secure-checkout/SecureCheckoutComponent";
import ModalComponent from "../../../shared/components/modal/ModalComponent";

interface TransactionDetailsScreenProps {

}

const TransactionTypes: TransactionType[] = ['invoice', 'receipt'];


const TransactionDetailsScreen = (props: TransactionDetailsScreenProps) => {

        const [isDetailsLoading, setIsDetailsLoading] = useState<boolean>(false);
        const [isDetailsLoaded, setIsDetailsLoaded] = useState<boolean>(false);
        const [transactionDetails, setTransactionDetails] = useState<any>(null);
        const [type, setType] = useState<TransactionType | undefined>(undefined);
        const [searchParams, setSearchParams] = useSearchParams();
        const [isSecureCheckOutModalOpen, setIsSecureCheckOutModalOpen] = useState(false);
        const {transactionId}: any = useParams();
        const navigate = useNavigate();

        useEffect(() => {
            const type: TransactionType = searchParams.get("type") as TransactionType;
            if (type && TransactionTypes.includes(type)) {
                setType(type);
            } else {
                searchParams.set("type", TransactionTypes[0]);
                setSearchParams(searchParams);
            }
        }, [searchParams, setSearchParams]);

        const fetchTransactionDetails = useCallback((transactionId: string) => {
            try {
                setIsDetailsLoading(true);
                setIsDetailsLoaded(false);
                let apiUrl: any;
                if (type === 'invoice') {
                    apiUrl = CommonService._transaction.GetInvoiceDetails(transactionId);
                } else if (type === 'receipt') {
                    apiUrl = CommonService._transaction.GetReceiptDetails(transactionId);
                } else {
                    return;
                }
                apiUrl.then((response: any) => {
                    setIsDetailsLoading(false);
                    setIsDetailsLoaded(true);
                    setTransactionDetails(response.data);
                }).catch((error: any) => {
                    setIsDetailsLoading(false);
                    setIsDetailsLoaded(true);
                    console.log(error);
                    setTransactionDetails(null)
                })
            } catch (error) {
                setIsDetailsLoading(false);
                setIsDetailsLoaded(true);
                setTransactionDetails(null)
            }

        }, [type]);

        useEffect(() => {
            if (transactionId) {
                fetchTransactionDetails(transactionId);
            }
        }, [transactionId, fetchTransactionDetails])

        const handleBack = useCallback(() => {
            if (type === 'receipt') {
                navigate(CommonService._routeConfig.Transaction() + '?active-tab=completedPayments')
            } else {
                navigate(CommonService._routeConfig.Transaction());
            }
        }, [navigate, type]);

        const handleCheckTotal = useCallback(() => {
                if (type === 'invoice') {
                    return transactionDetails?.total - transactionDetails?.discount;
                } else if (type === 'receipt') {
                    return transactionDetails?.payable_amount;
                }
            }, [transactionDetails, type]
        )
        return (
            <div className="transaction-details-screen">
                {
                    isDetailsLoading && <LoaderComponent/>
                }
                {
                    isDetailsLoaded && <>
                        <div className="list-screen__header mrg-bottom-20">
                            <div className="list-screen__header-title">
                                <BackComponent onClick={handleBack}/>
                            </div>
                        </div>
                        <div className={'ts-row'}>
                            <div className={'details-wrapper ts-col-lg-8 ts-col-md-12 ts-col-sm-12 pdd-bottom-20'}>
                                <CardComponent>
                                    <div className={'heading-status-wrapper'}>
                                        <div className={'heading-status-wrapper__heading'}>
                                            Payment Details
                                        </div>

                                        <div>
                                            {!transactionDetails?.appointment_details?.consultation_details?.is_single_session &&
                                                <ChipComponent
                                                    label={transactionDetails?.payment_for === 'waived' ? 'Fee:_Waived' : transactionDetails?.payment_for}
                                                    className={transactionDetails?.payment_for}/>}
                                            {
                                                transactionDetails?.payment_for === 'waived' && <>&nbsp;&nbsp;&nbsp;
                                                    <ChipComponent label={transactionDetails?.appointment_details?.status}
                                                                   className={transactionDetails?.appointment_details?.status}/>
                                                </>
                                            }
                                            {
                                                transactionDetails?.appointment_details?.consultation_details?.is_single_session &&
                                                <ChipComponent label={'Appointment'} className={'completed'}/>
                                            }
                                        </div>
                                    </div>
                                    <div className={'transaction-details-wrapper'}>

                                        <div className={'transaction-details-upper-item'}>
                                            <div className={'container'}>
                                                <div className={'icon-wrapper'}>
                                                    <ImageConfig.HashIcon height={30} width={30}/>
                                                </div>
                                                <div className={'details-wrapper'}>
                                                    <div>{type === 'invoice' ? 'Invoice No.' : 'Receipt No.'}</div>
                                                    <div
                                                        className={'mrg-top-5'}>
                                                        <b>{type === 'invoice' ? transactionDetails?.invoice_number : transactionDetails?.receipt_number}</b>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className={'container  justify-content-center'}>
                                                <div className={'icon-wrapper'}>
                                                    <ImageConfig.ClockIcon height={30} width={30}/>
                                                </div>
                                                <div className={'details-wrapper'}>
                                                    <div>{(transactionDetails?.record_type === 'medical_record' || transactionDetails?.appointment_details?.consultation_details?.is_single_session) ? 'Appointment Date & Time' : 'Transaction Date & Time'}</div>
                                                    <div
                                                        className={'mrg-top-5'}>
                                                        <b>{moment(transactionDetails?.appointment_date).format('DD-MMM-YYYY')} | {CommonService.getHoursAndMinutesFromMinutes(transactionDetails?.appointment_details?.start_time)}</b>
                                                    </div>

                                                </div>
                                            </div>
                                            {(transactionDetails?.appointment_details?.consultation_details?.is_single_session || transactionDetails?.record_type !== 'performance_record') &&
                                                <div className={'container justify-content-center last-container'}>
                                                    <div className={'icon-wrapper'}>
                                                        <ImageConfig.PersonIcon height={30} width={30}/>
                                                    </div>
                                                    <div className={'details-wrapper'}>
                                                        <div>Provider Name</div>
                                                        <div
                                                            className={'mrg-top-5 name-wrapper'}>
                                                            <b>{transactionDetails?.provider_details?.first_name ? transactionDetails?.provider_details?.first_name + ' ' + transactionDetails?.provider_details?.last_name : 'N/A'}</b>
                                                        </div>

                                                    </div>
                                                </div>}
                                            {(transactionDetails?.record_type === 'performance_record' && !transactionDetails?.appointment_details?.consultation_details?.is_single_session) &&
                                                <div className={'container justify-content-center last-container'}>
                                                    <div className={'icon-wrapper'}>
                                                        <ImageConfig.BundleIcon height={30} width={30}/>
                                                    </div>
                                                    <div className={'details-wrapper'}>
                                                        <div>Bundle Pack</div>
                                                        <div
                                                            className={'mrg-top-5'}>
                                                            <b>{transactionDetails?.purchased_bundle_pack_details?.consultation_title}</b>
                                                        </div>

                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        {transactionDetails?.payment_for !== 'products' && <>
                                            <div className={'description-wrapper'}>
                                                <div className={'icon-wrapper'}>
                                                    <ImageConfig.DocumentIcon height={30} width={30}/>
                                                </div>
                                                <div>
                                                    <div className={'description-heading'}>Description</div>
                                                    <div className={'description-body'}>
                                                        <b> {transactionDetails?.category_details?.name} - {transactionDetails?.service_details?.name}</b>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className={'description-wrapper last-container'}>
                                                <div className={'icon-wrapper'}>
                                                    <ImageConfig.DocumentClipIcon height={30} width={30}/>
                                                </div>
                                                <div>
                                                    <div className={'description-heading'}>Case Name</div>
                                                    <div className={'description-body'}>
                                                        {
                                                            (transactionDetails?.record_type === 'medical_record' && transactionDetails?.record_id) && (
                                                                <b>
                                                                    {CommonService.getDateFromTimezone(transactionDetails?.medical_record_details?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')}{' - '}
                                                                    {transactionDetails?.medical_record_details?.injury_details?.map((injury: any, index: number, array: any[]) => (
                                                                        <span key={index}>
                                                                            {" "}
                                                                            {injury.body_part_name}
                                                                            {injury?.body_side ? ` (${injury?.body_side})` : ''}
                                                                            {index !== array.length - 1 && " |"}
                                                                            </span>
                                                                    ))}
                                                                </b>
                                                            )
                                                        }
                                                        {
                                                            transactionDetails?.record_type === 'performance_record' && transactionDetails?.record_id &&
                                                            <>
                                                                <b> {CommonService.getDateFromTimezone(transactionDetails?.performance_record_details?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')} - {transactionDetails?.performance_record_details?.program_focus}</b>

                                                            </>
                                                        }
                                                        {
                                                            !transactionDetails?.record_id && <b>N/A</b>
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                        {
                                            transactionDetails?.payment_for === 'products' && <>
                                                <div className={'description-wrapper last-container'}>
                                                    <div className={'icon-wrapper'}>
                                                        <ImageConfig.DocumentIcon height={30} width={30}/>
                                                    </div>
                                                    <div>
                                                        <div className={'description-heading'}>Description</div>
                                                        <div className={'description-body'}>
                                                            <b> {transactionDetails?.service_details}</b>

                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <div>
                                        <div className={'invoice-name-heading'}>
                                            {type === 'invoice' ? 'Invoices' : 'Receipts'}
                                        </div>
                                        <AttachmentCard
                                            title={type && `General ${CommonService.capitalizeFirstLetter(type)}`}/>

                                    </div>
                                </CardComponent>
                            </div>
                            <div className={'ts-col-lg-4 ts-col-md-12 ts-col-sm-12'}>
                                <div className={'mrg-bottom-20'}>
                                    <ContactInfoCardComponent
                                        phoneNumber={transactionDetails?.facility_details?.primary_contact_info?.phone}
                                    />
                                </div>
                                <PaymentDetailsComponent
                                    enablePay={transactionDetails?.enable_pay_now}
                                    total={transactionDetails?.total - transactionDetails?.discount}
                                    discount={transactionDetails?.coupon_discount || 0}
                                    paymentStatus={type === 'invoice' ? 'unpaid' : 'paid'}
                                    paymentMethod={transactionDetails?.payment_mode && transactionDetails?.payment_mode}
                                    payableAmount={transactionDetails?.payment_for === 'waived' ? 0 : handleCheckTotal()}
                                    isWaived={transactionDetails?.payment_for === 'waived'}
                                    refundAmount={transactionDetails?.payment_for === 'waived' ? handleCheckTotal() : 0}
                                    onPayNowClick={() => setIsSecureCheckOutModalOpen(true)}/>
                            </div>
                        </div>
                        <ModalComponent isOpen={isSecureCheckOutModalOpen}
                                        closeOnBackDropClick={false}
                        >
                            <SecureCheckoutComponent setIsSecureCheckOutModalOpen={setIsSecureCheckOutModalOpen}
                                                     appointmentDetails={transactionDetails}
                                                     isComingFromListScreen={false}/>
                        </ModalComponent>

                    </>
                }
            </div>
        )
    }
;
export default TransactionDetailsScreen;
